import {
  logoDividerStyle,
  logoGradientTextStyle,
  logoPrimaryTextStyle,
  logoRowStyle,
  textLogoA11yProps,
  type TextLogoProps,
} from './textLogoStyles'

/** Gradient "LINA" wordmark — LINA Lens company mark */
export function LinaLensCompanyLogo({
  className,
  style,
  size = 40,
  'aria-label': ariaLabel = 'LINA',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoGradientTextStyle(size, 600), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      LINA
    </span>
  )
}

/** Charcoal "LENS" product mark */
export function LinaLensProductLogo({
  className,
  style,
  size = 40,
  'aria-label': ariaLabel = 'LENS',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoPrimaryTextStyle(size, 600), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      LENS
    </span>
  )
}

/** Horizontal "LINA LENS" full lockup */
export function LinaLensFullLogo({
  className,
  style,
  size = 40,
  'aria-label': ariaLabel = 'LINA Lens',
}: TextLogoProps) {
  // LENS renders a touch smaller than LINA — at equal font-size, solid black
  // text optically reads larger next to the lighter-weight gradient wordmark.
  const productSize = Math.round(size * 0.8)

  return (
    <span
      className={className}
      style={{ ...logoRowStyle(), ...style }}
      {...textLogoA11yProps(ariaLabel)}
    >
      <LinaLensCompanyLogo size={size} decorative />
      <span aria-hidden="true" style={logoDividerStyle(size)} />
      <LinaLensProductLogo size={productSize} decorative />
    </span>
  )
}
